// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"7064bf5a","222":"1885d9ac","286":"ab72aadc","514":"3b8fc127"}[chunkId] + ".chunk.css";
};